import {Box, Paper} from '@mui/material';
import {makeStyles} from '@mui/styles';
import {reverse} from 'named-urls';
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import OrderItems from '../../../../components/OrderItems';
import {ServiceContext} from '../../../../components/Services';
import Switched from '../../../../components/Switched';
import Switcher from '../../../../components/Switcher';
import routes from '../../../../routes';
import Delivery from './Delivery';
import Loading from './Loading';
import PackingLists from './PackingLists';

const useStyles = makeStyles((theme) => ({
  container: {
    '&.MuiPaper-root': {
      overflow: 'hidden',
      marginTop: theme.spacing(1),
    }
  }
}));

const Tabs = ({order, onOrderUpdated}) => {
  const services = useContext(ServiceContext);
  const classes = useStyles();
  const match = useRouteMatch();
  const [tab, setTab] = useState('');

  const tabs = useMemo(() => [
    {
      title: 'Items',
      slug: '',
      path: reverse(order.archived ? routes.archive.salesOrder.detail : routes.salesOrders.detail, {
        id: order?.id ?? 0
      })
    },
    {
      title: 'Loading / Terms',
      slug: 'loading',
      path: reverse(order.archived ? routes.archive.salesOrder.tab : routes.salesOrders.tab, {
        id: order?.id ?? 0,
        tab: 'loading'
      })
    },
    {
      title: 'Collection / Delivery',
      slug: 'collection',
      path: reverse(order.archived ? routes.archive.salesOrder.tab : routes.salesOrders.tab, {
        id: order?.id ?? 0,
        tab: 'collection'
      })
    },
    {
      title: 'Packing Lists',
      slug: 'packing-lists',
      path: reverse(order.archived ? routes.archive.salesOrder.tab : routes.salesOrders.tab, {
        id: order?.id ?? 0,
        tab: 'packing-lists'
      })
    }
  ], [order]);

  useEffect(() => {
    if (match.params?.tab && tabs.findIndex(t => t.slug) >= 0) {
      setTab(match.params?.tab);
    } else {
      setTab('');
    }
  }, [match, tabs]);

  return (
    <>
      <Switcher tabs={tabs}/>
      <Switched tab="" currentTab={tab}>
        <Paper className={classes.container}>
          <OrderItems order={order} onOrderUpdated={onOrderUpdated} service={services.salesOrder}/>
        </Paper>
      </Switched>
      <Switched tab="loading" currentTab={tab}>
        <Box marginTop={-1}>
          <Loading order={order} onOrderUpdated={onOrderUpdated}/>
        </Box>
      </Switched>
      <Switched tab="collection" currentTab={tab}>
        <Box marginTop={-1}>
          <Delivery order={order} onOrderUpdated={onOrderUpdated}/>
        </Box>
      </Switched>
      <Switched tab="packing-lists" currentTab={tab}>
        <Paper className={classes.container}>
          <PackingLists order={order}/>
        </Paper>
      </Switched>
    </>
  );
};

export default Tabs;
